import React, { Component } from 'react';
import { connect } from "react-redux";
import { Card } from '../../ui';

import AutosSoaWrapper from './AutosSoa.style';
import Steps from '../../Steps';
import { setStepsList } from "../../../actions";
import VehicleType from './VehicleType';
import Login from '../../Common/Login';
import AutoForm_1 from './AutoForm_1';
import AutoForm_2 from '../../Common/Autos/AutoForm_2';
import Payment from './Payment';

class AutosSOA extends Component {

  constructor(props) {
    super(props);

    this.state = {
      globalSteps: ['1. Tus datos', '2. Datos del vehículo', '3. Compra'],
      steps: [
        { pos: 0, global: -1, name: 'vehicleType', backButton: false },
        { pos: 1, global: -1, name: 'login' },
        { pos: 2, global:  0, name: 'autoForm_1' },
        { pos: 3, global:  1, name: 'autoForm_2' },
        { pos: 4, global:  2, name: 'payment' },
      ]
    };
  }

  componentDidMount() {
    const { steps } = this.state;
    const { setStepsList } = this.props;
    setStepsList(steps);
  }

  getStepContent() {
    const { selectedStep } = this.props;
    switch (selectedStep.name) {
      case 'vehicleType':
        return <VehicleType />;
      case 'login':
        return <Login />;
      case 'autoForm_1':
        return <AutoForm_1 />;
      case 'autoForm_2':
        return <AutoForm_2 isSOA />;
      case 'payment':
        return <Payment />;
    }
  }

  render() {
    const { globalSteps } = this.state;
    return (
      <Card className="Card--medium">
        <AutosSoaWrapper>
          <Steps globalSteps={globalSteps} />
          <div >
            {this.getStepContent()}
          </div>
        </AutosSoaWrapper>
      </Card>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    selectedStep: state.steps.selectedStep
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setStepsList: (steps) => {
      dispatch(setStepsList(steps));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AutosSOA);